import { Capacitor } from '@capacitor/core'
import { toast } from 'react-toastify'

import { ToastPushNotification } from '@apps-common/components/toast/ToastPushNotification'
import { ToastUI } from '@apps-common/components/toast/ToastUI'
import { buildPushNotificationIcon } from '@apps-common/config/push-notification'
import { WINDOW_DIMENSION_MOBILE } from '@apps-common/config/window-dimensions'
import { INotificationPayload } from '@apps-common/types/portal/push-registration'

export const TOAST_ID_PUSH_NOTIFICATION = 'toast-push-notification'
export const TOAST_ID_APP = 'toast-app'

export const toastSuccess = (message: string, closeIn?: number) => {
  toast(<ToastUI message={message} type='success' />, {
    containerId: TOAST_ID_APP,
    autoClose: closeIn || 5000
  })
}

export const toastWarning = (message: string, closeIn?: number) => {
  toast(<ToastUI message={message} type='warning' />, {
    containerId: TOAST_ID_APP,
    autoClose: closeIn || 5000
  })
}

export const toastError = (message: string, closeIn?: number) => {
  toast(<ToastUI message={message} type='error' />, {
    containerId: TOAST_ID_APP,
    autoClose: closeIn || 5000
  })
}

export const toastInfo = (message: string, closeIn?: number) => {
  toast(<ToastUI message={message} type='info' />, {
    containerId: TOAST_ID_APP,
    autoClose: closeIn || 5000
  })
}

export const toastCustom = (message: string, Icon: any, closeIn?: number) => {
  toast(<ToastUI message={message} icon={Icon} />, {
    containerId: TOAST_ID_APP,
    autoClose: closeIn || 5000
  })
}

export const toastPushNotification = (payload: INotificationPayload) => {
  const icon = buildPushNotificationIcon(payload)
  const isMobileView = typeof window !== 'undefined' && window.innerWidth <= WINDOW_DIMENSION_MOBILE
  const shouldAutoClose = Capacitor.isNativePlatform() || isMobileView

  console.log('TOAST =>', payload, icon)
  toast(<ToastPushNotification payload={payload} icon={icon} />, {
    toastId: payload.id,
    autoClose: shouldAutoClose ? 6000 : false,
    containerId: TOAST_ID_PUSH_NOTIFICATION
  })
}
